export function hasEmojiReactions(message) {
    return message.emojiReactions !== undefined && message.emojiReactions.length > 0;
}
export default [
    function () {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=eeeMessage',
            },
            controllerAs: 'ctrl',
            controller: ['WebClientService', '$filter', function (webClientService, $filter) {
                    const idsToNames = $filter('idsToNames');
                    this.$onInit = function () {
                        const message = this.message;
                        this.reactions = (message.emojiReactions ?? []).map(({ emoji, identities }) => {
                            return {
                                emoji,
                                length: identities.length,
                                names: idsToNames(identities, false),
                                includesMe: identities.includes(webClientService.me.id),
                            };
                        });
                    };
                }],
            template: `
                <div ng-if="ctrl.reactions.length > 0" class="bucket" ng-class="{'active': bucket.includesMe}" title="{{bucket.names}}" ng-repeat="bucket in ctrl.reactions">
                    <span class="emoji" ng-bind-html="bucket.emoji | escapeHtml | emojify"></span>
                    <span ng-if="bucket.length > 1" class="count">{{bucket.length}}</span>
                </div>
            `,
        };
    },
];
